import './index.scss';
import { navigateTo } from '@/Utils/routing';
import { useKoreanStudyType } from '@/Recoil/PersonaTest';

const questionData = [
    {   title: 'Alasan kamu belajar bahasa Korea?',
        options: [
            'Mau ngobrol sama orang Korea',
            'Bisa terpakai saat liburan ke Korea',
            'Mau nonton konten Korea tanpa subtitle',
            'Karena berguna untuk studi/karier'
        ]
    },
    {   title: 'Gambaran ideal diriku setelah bisa bahasa Korea adalah…',
        options: [
            'Saat teman Korea bilang "Kamu jago bahasa Korea!"',
            'Saat bisa pesan makan di Korea tanpa pakai translator',
            'Saat bisa paham konten Korea tanpa subtitle',
            'Saat dapat skor yang diinginkan di ujian Bahasa Korea'
        ],
    },
    {   title: 'Saat semangat belajar turun, apa yang bikin kamu balik belajar lagi?',
        options: [
            'Ketika lihat kosakata Korea yang belum kamu tahu di konten',
            'Ketika tanggal pergi ke Korea sudah dekat',
            'Ketika bingung menjawab pertanyaan dalam bahasa Korea',
            'Ketika tanggal ujian sudah dekat'
        ]
    },
    {   title: 'Metode belajar yang paling kamu suka adalah…',
        options: [
            'Idol Korea! alias K-Pop',
            'Drama & variety show! K-Content',
            'Webtoon & game! K-Story',
            'Gaya & tren Korea! K-Style'
        ]
    },
    {   title: 'Hal terpenting dalam belajar bahasa Korea adalah…',
        options: [
            'Bisa ngomong dengan lancar',
            'Bisa pakai tata bahasa dengan tepat',
            'Bisa hafal banyak kosakata',
            'Bisa mendengar dan paham dengan baik'
        ]
    },
    {   title: 'Kapan kamu merasa bahwa proses belajarmu berjalan dengan baik?',
        options: [
            'Level/score ujian Bahasa Korea meningkat',
            'Makin banyak paham konten Korea',
            'Mulai mengerti struktur grammar',
            'Lebih nyambung saat ngobrol'
        ]
    },
    {   title: 'Saat belajar kosakata baru, hal pertama yang kamu lakukan adalah…',
        options: [
            'Langsung pakai pas ngobrol',
            'Catat rapi di memo/notebook',
            'Ingat-ingat adegan/konten tempat kata itu muncul',
            'Membayangkan situasi apa yang cocok untuk memakai kata itu'
        ],
    },
    {   title: 'Tempat favoritmu untuk belajar bahasa Korea adalah…',
        options: [
            'Sekolah/kelas/les',
            'Rumah',
            'Kafe',
            'Online / Internet'
        ],
    },
    {   title: 'Notebook belajar Korea milikmu seperti apa?',
        options: [
            'Nggak punya buku catatan',
            'Kosakata & grammar tercatat dengan rapi',
            'Berisi lirik K-Pop & kata-kata cantik dengan stiker lucu',
            'Penuh catatan berbagai ekspresi yang praktis dipakai (contoh: Cara Memesan Minuman di Cafe)'
        ]
    },
    {   title: 'Cara belajar bahasa Korea yang kamu suka adalah…',
        options: [
            'Belajar ramai-ramai bersama teman',
            'Belajar fokus sendirian di tempat tenang',
            'Belajar bertahap sesuai dengan arahan guru',
            'Bukan belajar yang serius, tapi belajar sambil ngobrol dalam bahasa Korea'
        ]
    },
]

const QuestionView = ({quiznumber}: {quiznumber: number;}) => {
    const { getAnswer, setAnswer } = useKoreanStudyType();
    const questionIndex = quiznumber - 1; // 0-indexed
    const selectedOption = getAnswer(questionIndex);

    const totalQuestions = questionData.length;
    const { title, options } = questionData[questionIndex];
    const questionid = quiznumber.toString().padStart(2, '0');

    const handleOptionClick = (index: number) => {
        setAnswer(questionIndex, index as 0 | 1 | 2 | 3);
    };

    return (
        <div className="korean-study-type-test-container">
            <div className="content-wrapper">
                {/* Top Section */}
                <div className="top-section">
                    <div className="logo-wrapper">
                        <div className="logo-icon">
                            <img src="/img/matelogoguide.png" alt="MATE Logo" />
                        </div>
                        <span className="logo-text">MATE</span>
                    </div>
                    <div className="header-section">
                        <p className="header-title">Korean Language Personality Test</p>
                    </div>
                </div>

                {/* Contents */}
                <div className="contents">
                    {/* Pagination */}
                    <div className="pagination">
                        <div className="progress-bar">
                            <div
                                className="progress-fill"
                                style={{ width: `${quiznumber / totalQuestions * 100}%` }}
                            />
                        </div>
                        <p className="progress-text">
                            {questionid}/{String(totalQuestions).padStart(2, '0')}
                        </p>
                    </div>

                    {/* Question Section */}
                    <div className="question-section">
                        <p className="question-text">{questionid}. {title}</p>

                        <div className="selection-group">
                            {options.map((option, index) => (
                                <div
                                    key={index}
                                    className={`selection-box ${selectedOption === index ? 'selected' : ''}`}
                                    onClick={() => handleOptionClick(index)}
                                >
                                    <p className="option-text">{option}</p>
                                    <div className={`radio-button ${selectedOption === index ? 'checked' : ''}`}>
                                        {selectedOption === index && <div className="radio-inner" />}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
                <div className="cta-wrapper">
                    <button
                        disabled={quiznumber <= 1}
                        className="btn-back"
                        onClick={() =>
                            navigateTo(`/personatest/koreanstudytype/question/${(quiznumber-1).toString().padStart(2, '0')}`)
                        }>{"back"}</button>
                    <button
                        className="btn-next"
                        disabled={selectedOption === null}
                        onClick={()=> {
                            if (selectedOption === null) { return; }
                            if (quiznumber + 1 > totalQuestions) {
                                navigateTo('/personatest/koreanstudytype/complete');
                                return;
                            }
                            navigateTo(`/personatest/koreanstudytype/question/${(quiznumber+1).toString().padStart(2, '0')}`)
                        }}>{quiznumber === 10 ? `submit` : `next`}</button>
                </div>
            </div>
        </div>
    );
}

const Router = ({path}: {path: string}) => {
    const [, questionid] = /\/question\/(0[1-9]|10)/.exec(path) || [null, null];
    const idx = questionid ? parseInt(questionid, 10) : -1;

    if (idx >= 1 && idx <= questionData.length) {
        return <QuestionView quiznumber={idx} />;
    } else {
        return <div>{"Question not found"}</div>;
    }
}

export default Router;
